import { linkedinProfileUrlRegEx } from './regExs';

/** Returns true if value is a string that looks like a LinkedIn profile URL (in/pub/profile). */
export const isLinkedInProfileUrl = (value) => {
  if (value == null || typeof value !== 'string' || !value.trim()) return false;
  return linkedinProfileUrlRegEx.test(value.trim());
};

export const addProtocolToUrl = (url) => {
  if (!url || url === '') return url;

  if (url.startsWith('http')) {
    return url;
  }

  return `https://${url}`;
};

export const getDomainName = () => {
  const domainTokens = window.location.hostname.split('.');
  let domain = domainTokens[domainTokens.length - 1];

  if (domainTokens.length > 1) {
    domain = `${domainTokens[domainTokens.length - 2]}.${domain}`;
  }

  return domain;
};

/**
 * Generates a link to the jobs page with proper visibility filter
 * Jobs page URL with visibility=visible if not company-profile
 */
export const getJobsLink = ({ networkSlug, companySlug, isCompanyProfile = false }) => {
  let basePath;

  if (companySlug) {
    // Company jobs page
    const prefix = isCompanyProfile ? 'company-profile' : 'companies';
    basePath = `/networks/${networkSlug}/${prefix}/${companySlug}/jobs`;
  } else {
    // Main jobs page
    basePath = `/networks/${networkSlug}/jobs`;
  }

  // Add visibility=visible for non-company-profile routes
  if (!isCompanyProfile) {
    return `${basePath}?visibility=visible`;
  }

  return basePath;
};
